import React from 'react';
import ReactMarkdown from 'react-markdown';

/**
 * MarkdownContent - Shared component for rendering markdown safely
 *
 * Provides consistent markdown rendering across the app with:
 * - Security: HTML stripping to prevent XSS
 * - Styling: Uses chat-message-text CSS class for consistent formatting
 * - Custom components: Optional link handler for special behavior
 */
export default function MarkdownContent({
  children,
  className = 'chat-message-text',
  style,
  components,
}) {
  return (
    <div className={className} style={style}>
      <ReactMarkdown
        skipHtml={true}
        unwrapDisallowed={true}
        components={components}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
